document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  let busy = false;

  function getRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function installGroupedCartStyles() {
    if (document.querySelector('#me-grouped-cart-runtime-styles')) return;
    const style = document.createElement('style');
    style.id = 'me-grouped-cart-runtime-styles';
    style.textContent = `
      .me-grouped-cart > .cart-items__price,
      .me-grouped-cart .me-grouped-cart__unit-total { display:none!important; }
      @container cart-items (min-width:720px) {
        .me-grouped-cart { grid-template-columns:7.5rem minmax(0,1fr) auto!important; grid-template-areas:"media details quantity" "media details error"!important; }
        .me-grouped-cart .cart-items__details { grid-area:details!important; }
        .me-grouped-cart .cart-items__quantity { grid-area:quantity!important; justify-self:end; }
      }
      @container cart-items (max-width:719px) {
        .me-grouped-cart { grid-template-columns:clamp(4.5rem,21cqi,7.5rem) minmax(0,1fr)!important; grid-template-areas:"media details" "media quantity" "media error"!important; }
        .me-grouped-cart .cart-items__details { grid-area:details!important; }
        .me-grouped-cart .cart-items__quantity { grid-area:quantity!important; }
      }`;
    document.head.appendChild(style);
  }

  function removeCardPrices(root = document) {
    root.querySelectorAll('.me-grouped-cart > .cart-items__price, .me-grouped-cart .me-grouped-cart__unit-total').forEach((el) => el.remove());
  }

  function parseKeys(row) {
    return String(row?.dataset.meGroupKeys || '').split('|').map((key) => key.trim()).filter(Boolean);
  }

  function getQuantity(row) {
    const value = Number.parseInt(row.querySelector('[data-me-group-quantity]')?.value || '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function setBusy(row, value) {
    busy = value;
    row.classList.toggle('is-updating', value);
    row.querySelectorAll('button, input').forEach((control) => { control.disabled = value; });
  }

  function currentSection() {
    const wrapper = document.querySelector('[id^="shopify-section-"]:has([data-me-personalized-group])');
    if (!wrapper) return null;
    return { wrapper, id: wrapper.id.replace(/^shopify-section-/, '') };
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((node) => {
      node.textContent = String(count);
    });
  }

  function replaceCartSection(html, section) {
    if (!html || !section?.wrapper) return false;
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    section.wrapper.innerHTML = '';
    section.wrapper.append(...template.content.childNodes);
    removeCardPrices(section.wrapper);
    return true;
  }

  async function updateGroup(row, quantity) {
    if (busy) return;
    const keys = parseKeys(row);
    if (!keys.length) return;

    const previousQuantity = getQuantity(row);
    const nextQuantity = Math.max(0, Number(quantity) || 0);
    const input = row.querySelector('[data-me-group-quantity]');
    if (input && nextQuantity > 0) input.value = String(nextQuantity);
    setBusy(row, true);

    const updates = Object.fromEntries(keys.map((key) => [key, nextQuantity]));
    const section = currentSection();
    const payload = { updates };
    if (section?.id) {
      payload.sections = [section.id];
      payload.sections_url = location.pathname;
    }

    try {
      const response = await fetch(`${getRoot()}cart/update.js`, {
        method: 'POST',
        headers: {'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify(payload)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || 'Unable to update this personalized item.');

      updateHeaderCount(data.item_count ?? 0);
      const rendered = section?.id && replaceCartSection(data.sections?.[section.id], section);
      if (!rendered) window.location.reload();
    } catch (error) {
      if (input) input.value = String(previousQuantity);
      setBusy(row, false);
      window.alert(error.message || 'Unable to update the cart.');
    }
  }

  document.addEventListener('click', (event) => {
    const row = event.target.closest('[data-me-personalized-group]');
    if (!row) return;
    if (event.target.closest('[data-me-group-decrease]')) {
      event.preventDefault();
      updateGroup(row, Math.max(0, getQuantity(row) - 1));
    } else if (event.target.closest('[data-me-group-increase]')) {
      event.preventDefault();
      updateGroup(row, getQuantity(row) + 1);
    } else if (event.target.closest('[data-me-group-remove]')) {
      event.preventDefault();
      updateGroup(row, 0);
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-me-group-quantity]');
    if (!input) return;
    const row = input.closest('[data-me-personalized-group]');
    if (!row) return;
    const quantity = Math.max(1, Number.parseInt(input.value || '1', 10) || 1);
    input.value = String(quantity);
    updateGroup(row, quantity);
  });

  installGroupedCartStyles();
  removeCardPrices();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) removeCardPrices(node);
      }
    }
  }).observe(document.body, {childList:true, subtree:true});
});
